// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ajoutez ces styles dans votre fichier CSS ou balise <style> dans votre composant */

.facebook-image {
    border-radius: 8px; /* Coins arrondis */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Ombre légère */
    overflow: hidden; /* Masque le contenu débordant */
    transition: transform 0.2s, box-shadow 0.2s; /* Animation de transition fluide */
  }
  
  .facebook-image img {
    width: 100%;
    height: auto;
    display: block;
  }
  
  .facebook-image:hover {
    transform: scale(1.05); /* Effet d'agrandissement au survol */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Ombre légère augmentée */
  }
  
  `, "",{"version":3,"sources":["webpack://./src/pages/Marketing/Publication/publication.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;IACI,kBAAkB,EAAE,mBAAmB;IACvC,wCAAwC,EAAE,iBAAiB;IAC3D,gBAAgB,EAAE,gCAAgC;IAClD,2CAA2C,EAAE,mCAAmC;EAClF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,sBAAsB,EAAE,qCAAqC;IAC7D,wCAAwC,EAAE,2BAA2B;EACvE","sourcesContent":["/* Ajoutez ces styles dans votre fichier CSS ou balise <style> dans votre composant */\n\n.facebook-image {\n    border-radius: 8px; /* Coins arrondis */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Ombre légère */\n    overflow: hidden; /* Masque le contenu débordant */\n    transition: transform 0.2s, box-shadow 0.2s; /* Animation de transition fluide */\n  }\n  \n  .facebook-image img {\n    width: 100%;\n    height: auto;\n    display: block;\n  }\n  \n  .facebook-image:hover {\n    transform: scale(1.05); /* Effet d'agrandissement au survol */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Ombre légère augmentée */\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
